import { useCallback } from "react";
import { useScreenState } from "./useScreenState.js";
import { selectedTab } from "../lib/tabState.js";

export function useTabState(scope, fallback, available) {
  const [saved, setSaved] = useScreenState(scope, { activeTab: fallback },
    value => ({ activeTab: selectedTab(value.activeTab, fallback, available) }));
  const setTab = useCallback(next => setSaved(previous => {
    const current = selectedTab(previous.activeTab, fallback, available);
    return { activeTab: selectedTab(typeof next === "function" ? next(current) : next, current, available) };
  }), [setSaved, fallback, available]);
  return [saved.activeTab, setTab];
}
